import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTietPhieu } from "./ModalChiTietPhieu";

export const BtnChiTietPhieu = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a
        onClick={handleShow}
        href={() => false}
        className="blue word-break center-flex btn-link"
      >
        {item.ThuChiCode}
      </a>

      {show && (
        <ModalChiTietPhieu
          show={show}
          onHide={handleClose}
          thuchiId={item.ThuChiID}
        />
      )}
    </>
  );
};
